// extracted by mini-css-extract-plugin
module.exports = {"customTip":"TipsApplier_customTip__2Lc-o"};